export default __webpack_public_path__ + "static/media/main.e260ab08.jpg";